import "./cases.css";

import c1 from "./img/mini-case1.jpg";
import c2 from "./img/mini-case2.jpg";
import c3 from "./img/mini-case3.jpg";
import c4 from "./img/mini-case4.jpg";

function Cases() {
	return (
		<div className="cases__container">
			<h4 className="cases__title">Кейсы</h4>
			<div className="cases__grid">

				<a href="https://equilibrium.io/" target="_blank" className="cases__item">
					<img src={c3} alt="All-in-one DeFi hub of Polkadot. High leverage. Yet resilient" />
				</a>
				
				<a href="https://www.behance.net/gallery/210855871/mobilnoe-prilozhenie-vmeste-UXUI"  target="_blank" className="cases__item">
					<img src={c1} alt="" />
				</a>
				<a href="https://www.goodday.work/" target="_blank" className="cases__item">
					<img src={c2} alt="Платформа управления работой. Инструменты для планирования, управления проектами и продуктами" />
				</a>

			</div>
		</div>
	);
}

export default Cases;
